import frameOne from '../assets/images/accueil4.jpg';
import frameTwo from '../assets/images/accueil5.jpg';
import frameThree from '../assets/images/accueil6.webp';
import frameFour from '../assets/images/accueil9.jpeg';

const carouselImages = [
  {
    id: 'hero-1',
    image: frameOne,
    headline: 'Unisport du Haut-Nkam',
    subline: "Ntam Nkwae : jouer jusqu'au sacrifice suprême"
  },
  {
    id: 'hero-2',
    image: frameTwo,
    headline: 'Force Rouge & Jaune',
    subline: 'Des supporters passionnés sur tous les continents'
  },
  {
    id: 'hero-3',
    image: frameThree,
    headline: 'Académie & Performance',
    subline: 'Former les talents de demain en gardant l’exigence du haut niveau'
  },
  {
    id: 'hero-4',
    image: frameFour,
    headline: 'MPA’CHI Collection',
    subline: 'Une boutique connectée pour vivre la légende UHK'
  }
];

export default carouselImages;
